import React, { Component } from "react";
import { connect } from "react-redux";
import {
    receiveMessage,
    requestMessages
} from "../store/actions/messageActions";
import Message from "./Message";

class MessageList extends Component {
    componentDidMount() {
        this.props.connection.on(
            "ReceiveMessage",
            (user, message, roomId, messageId, postedAt, fromApotheek) => {
                this.props.onReceiveMessage(
                    user,
                    message,
                    roomId,
                    messageId,
                    postedAt,
                    fromApotheek,
                    this.props.currentRoom.id
                );
            }
        );

        this.props.onRequestMessages(this.props.roomId);
        this.scrollToBottom();
    }

    componentDidUpdate(prevProps) {
        if (this.props.roomId !== prevProps.roomId) {
            this.props.onRequestMessages(this.props.roomId);
        }
        this.scrollToBottom();
    }

    scrollToBottom() {
        this.el.scrollIntoView({ behavior: 'smooth' });
    }

    render() {
        const isapotheek = window.location.search.includes("ovisapotheek");

        if (!this.props.roomId) {
            return (
                <div className="message-list">
                    <div className="join-room">Join a room to start chatting.</div>
                </div>
            );
        }
        return (
            <div className="message-list">
                <div className={isapotheek ? "message-list-header-apotheek" : "message-list-header-zorgmedewerker"}>
                    <h3>Chat met {isapotheek ? this.props.currentRoom.tehuisgroepName : this.props.currentRoom.pharmacyName}</h3>
                    {isapotheek ? "" : <p>{"Je stuurt een bericht aan de gekoppelde apotheek van de cli\u00EBnt. Heb je een spoedvraag? Bel met de apotheek."}</p>}
                </div>
                {this.props.messages.map((message, i) => {
                    return (
                        <Message
                            key={i}
                            userName={message.userName}
                            contents={message.contents}
                            postedAt={message.postedAt}
                            isPersonal={isPersonal(message.fromApotheek, isapotheek)}
                        />
                    );
                })}
                <div ref={el => { this.el = el; }} />
            </div>
        );
    }
}

function isPersonal(fromApotheek, apotheekInUrl) {
    if (fromApotheek && apotheekInUrl) {
        return true;
    }
    if (!fromApotheek && !apotheekInUrl) {
        return true;
    }

    return false;
}

const mapStateToProps = state => {
    return {
        messages: state.requestMessages.messages,
        currentRoom: state.requestRooms.currentRoom
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onRequestMessages: currentRoomId =>
            dispatch(requestMessages(currentRoomId)),
        onReceiveMessage: (
            user,
            message,
            roomId,
            messageId,
            postedAt,
            isPersonal,
            currentRoomId
        ) =>
            dispatch(
                receiveMessage(
                    user,
                    message,
                    roomId,
                    messageId,
                    postedAt,
                    isPersonal,
                    currentRoomId
                )
            )
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessageList);



// WEBPACK FOOTER //
// ./src/components/MessageList.js